export class OrganizationStep1FormResultKeys {
    // Organization Profile
    static readonly PHONE_EXT = 'form_organization_step_1_field_phone_ext';
    static readonly PHONE = 'form_organization_step_1_field_phone';
    static readonly POSTAL_CODE = 'form_organization_step_1_field_postal_code';
    static readonly PROVINCE = 'form_organization_step_1_field_province';
    static readonly CHANGE_DATE =
        'form_organization_step_1_field_enterprise_legal_name_change_date';

    static readonly LEGAL_NAME_CHANGE =
        'form_organization_step_1_field_enterprise_legal_name_change';

    static readonly COMMERCIAL_NAME = 'form_organization_step_1_field_commercial_name';
    static readonly LEGAL_NAME = 'form_organization_step_1_field_legal_name';
    static readonly ORGANIZATION_TYPE = 'form_organization_step_1_field_organization_type';
    static readonly ORGANIZATION_OPERATION = 'form_organization_step_1_field_operation';
    static readonly EMAIL = 'form_organization_step_1_field_email';
    static readonly CSPAAT = 'form_organization_step_1_field_cspaat';
    static readonly COMMERCIAL_BANNER = 'form_organization_step_1_field_commercial_banner';
    static readonly PCA = 'form_organization_step_1_field_pca';
    static readonly ADDRESS = 'form_organization_step_1_field_address';
    static readonly CITY = 'form_organization_step_1_field_city';
    static readonly MANAGING_SOFTWARE = 'form_organization_step_1_field_managing_software';
    static readonly MANAGING_SOFTWARE_OTHER =
        'form_organization_step_1_field_managing_software_other';

    static readonly COMMUNICATION = 'form_organization_step_1_field_authorization_communication';

    // Additional info
    static readonly PROPERTY_TRANSFER =
        'form_organization_step_1_field_enterprise_property_transfer';

    static readonly PROPERTY_TRANSFER_DATE =
        'form_organization_step_1_field_enterprise_property_transfer_date';

    static readonly CLINICAL_ENV =
        'form_organization_step_1_field_enterprise_clinical_environnement';

    // Business info
    static readonly ENTERPRISE_NUMBER = 'form_organization_step_1_field_enterprise_number';
    static readonly TPS = 'form_organization_step_1_field_enterprise_tps';
    static readonly RT = 'form_organization_step_1_field_enterprise_rt';

    // Reasons
    static readonly REASON = 'form_organization_step_1_field_register_reason';
    static readonly REASON_OTHER = 'form_organization_step_1_field_reason_other';
}

export interface IOrganizationStep1FormResultModel {
    form_organization_step_1_field_phone_ext: string;
    form_organization_step_1_field_phone: string;
    form_organization_step_1_field_postal_code: string;
    form_organization_step_1_field_province: string;
    form_organization_step_1_field_commercial_name: string;
    form_organization_step_1_field_legal_name: string;
    form_organization_step_1_field_organization_type: string;
    form_organization_step_1_field_operation: string;
    form_organization_step_1_field_email: string;
    form_organization_step_1_field_cspaat: string;
    form_organization_step_1_field_commercial_banner: string;
    form_organization_step_1_field_pca: string;
    form_organization_step_1_field_address: string;
    form_organization_step_1_field_city: string;
    form_organization_step_1_field_managing_software: string;
    form_organization_step_1_field_managing_software_other: string;
    form_organization_step_1_field_authorization_communication: boolean;

    // Additional info
    form_organization_step_1_field_enterprise_clinical_environnement: string;
    form_organization_step_1_field_enterprise_property_transfer: boolean;
    form_organization_step_1_field_enterprise_property_transfer_date: string;
    form_organization_step_1_field_enterprise_legal_name_change: boolean;
    form_organization_step_1_field_enterprise_legal_name_change_date: string;

    // Business info
    form_organization_step_1_field_enterprise_number: number;
    form_organization_step_1_field_enterprise_tps: number;
    form_organization_step_1_field_enterprise_rt: number;

    // Reasons
    form_organization_step_1_field_reason_other: string;
    form_organization_step_1_field_register_reason: string;
}
